module.exports = __webpack_public_path__ + "img/26.d20fb19f.jpg";